import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PersonalVerificationInfoReducer } from '../reducers';

export const selectPersonalVerificationInfoFeature = createFeatureSelector<PersonalVerificationInfoReducer.PersonalVerificationInfoState>(
  PersonalVerificationInfoReducer.featureName
);

export const selectPersonalVerificationInfo = createSelector(selectPersonalVerificationInfoFeature, ({ items }) => items);
export const selectPersonalVerificationList = createSelector(selectPersonalVerificationInfoFeature, ({ list }) => list);
